module.exports = "input.form-control {\n  margin-bottom: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/presentations/widgets/webpage/webpage.widget.scss
// module id = ./src/app/views/presentations/widgets/webpage/webpage.widget.scss
// module chunks = main